import {createFileRoute} from '@tanstack/react-router';

import PatientTerminateStudy from '@/practitioner/views/patient/PatientTerminateStudy';

export const Route = createFileRoute('/(practitioner)/patients/$patientId/terminate-study')({
  component: PatientTerminateStudy,
  loader: ({params}) => ({
    patientId: params.patientId
  })
});
